export default "__VITE_ASSET__7D1sGoDK__"